import { MutationTree } from 'vuex';
import { State, MainContainerColor } from '@/core/store/general/state';

import Constants from '@/constants/constants';

export interface Mutations {
  setNavbarOpen: { token: string };
  setScrollTop: { token: string };
}

export const mutations: MutationTree<State> = {
  setNavbarOpen: (state, payload) => {
    state.openNavbar = payload;
    localStorage.setItem('open-navbar', payload);
  },
  setScrollTop: (state, payload) => {
    state.scrollTop = payload;
  },
  setDelegationList: (state, payload) => {
    state.delegationList = payload;
  },
  setLocationList: (state, payload) => {
    state.locationList = payload;
  },
  setServerError: (state, payload) => {
    if (Array.isArray(payload)) {
      payload = payload[0];
    } else if (payload.detail) {
      payload = payload.detail;
    }
    if (!payload) {
      payload = Constants.internalServerErrorMessage;
    }
    state.serverError = payload;
    setTimeout(() => {
      state.serverError = '';
    }, Constants.notificationMessageTimeToAppear);
  },
  setClientMainContainerColorWhite: (state) => {
    state.clientMainContainerColor = MainContainerColor.White;
  },
  setClientMainContainerColorGreyCustom: (state) => {
    state.clientMainContainerColor = MainContainerColor.GreyCustom;
  },
  setClientMainContainerColorGreyLight: (state) => {
    state.clientMainContainerColor = MainContainerColor.GreyLight;
  },
};
